/*global google*/
import React, { Component } from 'react';
import firebase from '../../helper/firebase';

import _ from 'lodash';

import isUrl from 'is-url';
import MUIPlacesAutocomplete from 'mui-places-autocomplete';

import { Link } from 'react-router-dom';

import Head from '../../components/Head';
import JobCardMedia from '../../components/JobCardMedia';
import JobCardHeader from '../../components/JobCardHeader';
import JobCardContent from '../../components/JobCardContent';
import LoggedOutCard from '../../components/LoggedOutCard';
import UnpublishedJob from '../../components/UnpublishedJob';
import DialogAlert from '../../components/DialogAlert';
import ViewMoreFeedBtn from '../../components/ViewMoreFeedBtn';
import AddressLinkBar from '../../components/AddressLinkBar';
import UnauthorizedText from '../../components/UnauthorizedText';
import ApplicantCardHeader from '../../components/ApplicantCardHeader';
import SkeletonCard from '../../components/SkeletonCard';

import {
	Avatar,
	Button,
	Card,
	CardActions,
	CardContent,
	CardMedia,
	CircularProgress,
	Divider,
	IconButton,
	LinearProgress,
	List,
	ListSubheader,
	ListItem,
	ListItemIcon,
	ListItemText,
	ListItemSecondaryAction,
	Radio,
	Switch,
	TextField,
	Typography
} from 'material-ui';

import { FormControlLabel, FormGroup, FormLabel } from 'material-ui/Form';

import Fade from 'material-ui/transitions/Fade';

import CheckIcon from 'material-ui-icons/Check';
import AddAPhotoIcon from 'material-ui-icons/AddAPhoto';
import DeleteIcon from 'material-ui-icons/Delete';

import { ReactGoogleAnalytics } from '../../helper/functions';

import { bgWhite, Title } from '../../helper/consts';

const style = {
	loading: {
		alignSelf: 'center',
		width: '75px',
		height: '75px',
		marginTop: 'calc(50vh - 37.5px - 64px)'
	},
	image: {
		maxHeight: '370px',
		minHeight: '244px',
		backgroundPosition: 'center',
		backgroundSize: 'cover',
		height: '33vw',
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
		backgroundColor: bgWhite,
		cursor: 'pointer'
	},
	logo: { display: 'flex' },
	logoAvatar: { cursor: 'pointer' },
	logoAvatarError: { backgroundColor: 'red' },
	logoName: {
		backgroundColor: '#eeeeee',
		padding: '0 21px',
		color: 'rgba(135,135,135,1)',
		borderRadius: '3px',
		height: '41px',
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
		marginLeft: '4px'
	},
	logoImageError: { color: 'red' },
	jobActions: { marginBotton: '15px' },
	statusContainer: {
		display: 'flex',
		flexWrap: 'wrap',
		alignItems: 'center'
	},
	statusLabel: { marginRight: '7px' },
	statusLabels: { textTransform: 'capitalize' },
	newListItemContainer: {
		display: 'flex',
		alignItems: 'flex-end'
	},
	unauthorizedContainer: {
		width: '100%',
		height: '70vh'
	}
};

export default class EditJob extends Component {
	constructor(props) {
		super(props);

		this.state = {
			newResponsibility: '',
			newQualification: '',
			jobStatusOptions: []
		};
	}

	static getDerivedStateFromProps(nextProps, prevState) {
		if (
			!prevState.loading &&
			!!nextProps.loggedin &&
			!!nextProps.jobs[this.props.match.params.jid]
		) {
			return {
				...nextProps.jobs[this.props.match.params.jid],
				job: nextProps.jobs[this.props.match.params.jid]
			};
		}
	}

	componentWillUnmount() {
		console.log('unmounting');
		this.props.uid &&
			this.props.loggedIn &&
			firebase
				.database()
				.ref(`myJobs/${this.props.uid}`)
				.off();
	}

	componentDidMount() {
		if (!this.props.jobs[this.props.match.params.jid]) {
			this.props.actions.getJob(this.props.match.params.jid);
		} else {
			this.setState({
				...this.props.jobs[this.props.match.params.jid],
				job: this.props.jobs[this.props.match.params.jid]
			});
		}
		let references = [
			{
				uid: '',
				stateName: 'myJobs',
				dbName: 'myJobs',
				dispatchName: 'JobsState/GET_MYJOBS',
				getJobs: true
			}
		];
		this.props.actions.getMyListener(references);
		this.getStatusOptions();
	}

	getStatusOptions = () => {
		let { jobStatusOptions } = this.state;
		firebase
			.database()
			.ref(`jobStatusOptions`)
			.once('value')
			.then(snap => {
				snap.forEach(snapshot => {
					if (snapshot.val() === true) {
						jobStatusOptions.push(snapshot.key);
						this.setState({ jobStatusOptions });
					}
				});
			});
	};

	renderPreview = () => {
		let html = [];
		const {
			created,
			companyURI,
			company,
			about,
			location,
			logo,
			image,
			title,
			imageFileUrl
		} = this.state;
		const job = {
			created,
			company,
			about,
			logo,
			image,
			location,
			title,
			companyURI
		};
		if (this.state.logoFileUrl) {
			job.logo.downloadURLs[0] = this.state.logoFileUrl;
		}
		let localImage = { downloadURLs: [imageFileUrl] };
		if (this.state.imageFileUrl) {
			job.image = localImage;
		}
		let card = (
			<Fade in={true} key={'preview'}>
				<Card className="card">
					{job.image !== undefined ? (
						<JobCardMedia job={job} />
					) : this.state.imageFileUrl ? (
						<JobCardMedia job={job} />
					) : null}
					<JobCardHeader job={job} />
					<Divider light />
					<JobCardContent job={this.state} />
					<Divider light />
					<AddressLinkBar location={job.location} />
				</Card>
			</Fade>
		);
		html.push(card);
		return html;
	};

	renderHiredCard = () => {
		const job = this.props.jobs[this.props.match.params.jid];
		if (!job) return;
		let html = [];
		let card = (
			<Card className="card" key={job.jid}>
				<JobCardHeader job={job} />
				<JobCardContent job={job} />
				<UnpublishedJob status={job.status} />
			</Card>
		);
		html.push(card);
		return html;
	};

	checkCompanyURI = event => {
		let status = isUrl(event.target.value);
		this.setState({ companyURIError: !status });
		this.clearErrors();
	};

	clearErrors = () => {
		this.setState({
			facebookError: false,
			twitterError: false,
			linkedinError: false,
			imageError: false,
			logoError: false,
			companyError: false,
			aboutError: false,
			titleError: false,
			locationError: false,
			detailsError: false
		});
	};

	handleFormInput = (e, formField) => {
		this.setState({ [`${formField}`]: e.target.value });
		this.clearErrors();
	};

	saveNewQualificationWithEnter = e =>
		e.key === 'Enter' && this.saveNewQualification();

	saveNewResponsibilityWithEnter = e =>
		e.key === 'Enter' && this.saveNewResponsibility();

	renderForm = () => {
		let self = this;
		let html = [];
		let card = (
			<Card className="card" key="JobForm">
				<ApplicantCardHeader applicant={this.props.auth} />
				<Divider light />
				<div className="image">
					<input
						onChange={this.handleImageSelect}
						accept="image"
						style={{ display: 'none' }}
						id="image"
						multiple
						type="file"
					/>
					<label htmlFor="image">
						<CardMedia
							image={
								this.state.imageFileUrl
									? this.state.imageFileUrl
									: this.state.image
										? this.state.image.downloadURLs
											? this.state.image.downloadURLs[0]
											: ''
										: ''
							}
							title={'Edit Job Banner Image'}
							style={style.image}
						>
							{this.state.imageFileUrl ? null : <AddAPhotoIcon />}
							<Typography
								style={this.state.imageError ? style.logoImageError : null}
							>
								{this.state.imageError ? '*' : null}
							</Typography>
						</CardMedia>
					</label>
				</div>
				<CardContent>
					<div style={style.logo} className="logo">
						<input
							onChange={this.handleLogoSelect}
							accept="image"
							style={{ display: 'none' }}
							id="logo"
							multiple
							type="file"
						/>
						<label htmlFor="logo">
							<Avatar
								src={
									this.state.logoFileUrl ||
									(this.state.logo &&
									this.state.logo.downloadURLs &&
									this.state.logo.downloadURLs[0]
										? this.state.logo.downloadURLs[0]
										: null)
								}
								style={
									this.state.logoError
										? style.logoAvatarError
										: style.logoAvatar
								}
							>
								{this.state.logo ? null : <AddAPhotoIcon />}
							</Avatar>
						</label>
						<Typography style={this.state.logoError ? style.logoError : null}>
							*
						</Typography>
						{this.state.logoFilename ? (
							<Typography
								style={style.logoName}
								align="left"
								color="inherit"
								type="body2"
							>
								Filename: {this.state.logoFilename}
							</Typography>
						) : null}
					</div>
					<TextField
						error={this.state.companyError}
						required
						fullWidth
						id="company"
						label="Company Name"
						value={this.state.company}
						onChange={e => {
							this.handleFormInput(e, 'company');
						}}
						margin="normal"
					/>
					<TextField
						error={this.state.aboutError}
						required
						fullWidth
						multiline
						id="about"
						label="About Company"
						value={this.state.about}
						onChange={e => {
							this.handleFormInput(e, 'about');
						}}
						margin="normal"
					/>
					<TextField
						error={this.state.titleError}
						required
						fullWidth
						id="title"
						label="Title"
						value={this.state.title}
						onChange={e => {
							this.handleFormInput(e, 'title');
						}}
						margin="normal"
					/>

					<MUIPlacesAutocomplete
						onSuggestionSelected={suggestion => this.setLocation(suggestion)}
						renderTarget={() => <span />}
						createAutocompleteRequest={inputValue => {
							this.setState({ location: inputValue });
							return {
								input: inputValue,
								types: ['geocode'],
								location: { lat: () => 43.650479, lng: () => -79.391301 },
								radius: 50000
							};
						}}
						textFieldProps={{
							value: self.state.location,
							// error: self.state.addressError,
							required: true,
							fullWidth: true,
							id: 'address',
							label: 'Location',
							margin: 'normal',
							placeholder: '111 Richmond Street West, Toronto, Ontario'
						}}
					/>

					<TextField
						error={this.state.detailsError}
						required
						fullWidth
						multiline
						id="details"
						label="Job Details"
						value={this.state.details}
						onChange={e => {
							this.handleFormInput(e, 'details');
						}}
						margin="normal"
					/>
					<TextField
						type="number"
						error={this.state.glassdoorIdError}
						fullWidth
						id="glassdoorId"
						label="Glassdoor ID"
						value={this.state.glassdoorId}
						onChange={e => {
							this.handleFormInput(e, 'glassdoorId');
						}}
						margin="normal"
					/>
					<List>
						{!_.isEmpty(this.state.responsibilities) && (
							<ListSubheader
								disableSticky
							>{`Job Responsibilities`}</ListSubheader>
						)}
						{!_.isEmpty(this.state.responsibilities) &&
							this.state.responsibilities.map((responsibility, i) => {
								return (
									<ListItem key={i} dense>
										<ListItemIcon>
											<CheckIcon />
										</ListItemIcon>
										<ListItemText primary={`${responsibility}`} />
										<ListItemSecondaryAction>
											<IconButton
												onClick={() => {
													this.deleteResponsibility(i);
												}}
												aria-label="Delete"
											>
												<DeleteIcon />
											</IconButton>
										</ListItemSecondaryAction>
									</ListItem>
								);
							})}
					</List>
					<div style={style.newListItemContainer}>
						<TextField
							error={this.state.responsibilitiesError}
							fullWidth
							id="responsibilities"
							label="Add Responsibility"
							multiline
							value={this.state.newResponsibility}
							onChange={e => {
								this.handleFormInput(e, 'newResponsibility');
							}}
							onKeyPress={this.saveNewResponsibilityWithEnter}
							margin="normal"
						/>
						<IconButton
							onClick={this.saveNewResponsibility}
							aria-label="Save"
							disabled={this.state.newResponsibility.length === 0}
							color="primary"
						>
							<CheckIcon />
						</IconButton>
					</div>
					<List>
						{this.state.qualifications.length !== 0 ? (
							<ListSubheader
								disableSticky
							>{`Candidate Qualifications`}</ListSubheader>
						) : null}
						{this.state.qualifications.map((qualification, i) => {
							return (
								<ListItem key={i} dense>
									<ListItemIcon>
										<CheckIcon />
									</ListItemIcon>
									<ListItemText primary={`${qualification}`} />
									<ListItemSecondaryAction>
										<IconButton
											onClick={() => {
												this.deleteQualification(i);
											}}
											aria-label="Delete"
										>
											<DeleteIcon />
										</IconButton>
									</ListItemSecondaryAction>
								</ListItem>
							);
						})}
					</List>
					<div style={style.newListItemContainer}>
						<TextField
							error={this.state.qualificationsError}
							fullWidth
							id="qualifications"
							label="Add Qualification"
							multiline
							value={this.state.newQualification}
							onChange={e => {
								this.handleFormInput(e, 'newQualification');
							}}
							onKeyPress={this.saveNewQualificationWithEnter}
							margin="normal"
						/>
						<IconButton
							onClick={this.saveNewQualification}
							aria-label="Save"
							disabled={this.state.newQualification.length === 0}
							color="primary"
						>
							<CheckIcon />
						</IconButton>
					</div>
					<TextField
						error={this.state.companyURIError}
						fullWidth
						id="companyURI"
						label="Company URI"
						placeholder={`https://www.${Title}.com`}
						helperText={
							this.state.companyURIError
								? `Please enter a valid URI in the form: https://www.${
										document.title
								  }.com`
								: null
						}
						value={this.state.companyURI}
						onChange={event => {
							this.setState({ companyURI: event.target.value });
							this.checkCompanyURI(event);
						}}
						margin="normal"
					/>
					<TextField
						error={this.state.commissionError}
						fullWidth
						id="commission"
						label="Commission"
						required
						type="number"
						helperText={
							this.state.commissionError
								? `Please enter a valid commission amount, with a minimum 1,000.`
								: null
						}
						value={this.state.commission}
						onChange={e => {
							this.handleFormInput(e, 'commission');
						}}
						margin="normal"
					/>
					<div style={style.statusContainer} className="statusContainer">
						<FormLabel style={style.statusLabel}>Status: </FormLabel>
						{this.renderJobStatusOptions()}
					</div>
					<FormGroup>
						<FormControlLabel
							control={
								<Switch
									checked={this.state.privateCompanyStats}
									onChange={(event, checked) =>
										this.setState({ privateCompanyStats: checked })
									}
								/>
							}
							label="Private Company Stats"
						/>
					</FormGroup>
				</CardContent>
				<CardActions style={style.jobActions}>
					{this.state.posted ? (
						<Link to={`/Jobs`}>
							<Button raised>Jobs</Button>
						</Link>
					) : (
						<Link to={`/Jobs`}>
							<Button raised>Cancel</Button>
						</Link>
					)}
					<Button
						disabled={this.state.posting}
						onClick={this.state.posted ? null : this.validate}
						raised={!this.state.posted}
						color={this.state.posted ? 'accent' : 'primary'}
					>
						{this.state.posted ? (
							<CheckIcon />
						) : this.state.posting ? (
							'Posting'
						) : (
							'Save'
						)}
					</Button>
				</CardActions>
				{this.state.uploadProgress > 0 && this.state.uploadProgress < 100 ? (
					<LinearProgress
						color="accent"
						mode="determinate"
						value={this.state.uploadProgress}
					/>
				) : null}
			</Card>
		);
		html.push(card);
		return html;
	};

	setLocation = location => {
		this.setState({ location: location.description });
		let geocoder = new google.maps.Geocoder();
		geocoder.geocode({ address: location.description }, (results, status) => {
			if (
				status === 'OK' &&
				!!results[0] &&
				!!results[0].geometry &&
				!!results[0].geometry.location
			) {
				let lat = results[0].geometry.location.lat();
				let lng = results[0].geometry.location.lng();
				this.setState({ geopoint: new firebase.firestore.GeoPoint(lat, lng) });
			}
		});
	};

	deleteQualification = i => {
		let { qualifications } = this.state;
		qualifications.splice(i, 1);
		this.setState({ qualifications });
	};
	saveNewQualification = () => {
		let { newQualification, qualifications } = this.state;
		if (newQualification.length === 0) {
			this.props.actions.setSnack(
				true,
				'Error: Please enter text to add to qualifications.'
			);
			return;
		}
		qualifications.push(newQualification);
		this.setState({ qualifications, newQualification: '' });
	};

	deleteResponsibility = i => {
		let { responsibilities } = this.state;
		responsibilities.splice(i, 1);
		this.setState({ responsibilities });
	};

	saveNewResponsibility = () => {
		let { newResponsibility, responsibilities } = this.state;
		if (newResponsibility.length === 0) {
			this.props.actions.setSnack(
				true,
				'Error: Please enter text to add to qualifications.'
			);
			return;
		}
		responsibilities.push(newResponsibility);
		this.setState({ responsibilities, newResponsibility: '' });
	};

	handleImageSelect = e => {
		let file = e.target.files[0];
		if (file) {
			if (file.type.match('image')) {
				let reader = new FileReader(file);
				reader.onloadend = () => {
					this.setState({
						imageFile: file,
						imageFilename: file.name,
						imageFileUrl: reader.result,
						imageError: false,
						logoError: false
					});
				};
				if (file !== undefined) {
					reader.readAsDataURL(file);
				}
			} else {
				this.props.actions.setSnack(
					true,
					'Error: Please upload (png,jpg,jpeg)'
				);
				this.setState({ imageError: true });
			}
		}
	};

	handleLogoSelect = e => {
		let file = e.target.files[0];
		if (file) {
			if (file.type.match('image')) {
				let reader = new FileReader(file);
				reader.onloadend = () => {
					this.setState({
						logoFile: file,
						logoFilename: file.name,
						logoFileUrl: reader.result,
						logoError: false,
						imageError: false
					});
				};
				if (file !== undefined) {
					reader.readAsDataURL(file);
				}
			} else {
				this.props.actions.setSnack(
					true,
					'Error: Please upload (png,jpg,jpeg)'
				);
				this.setState({ logoError: true });
			}
		}
	};

	renderJobStatusOptions = () => {
		let html = [];
		this.state.jobStatusOptions.forEach(option => {
			let item = (
				<FormControlLabel
					control={<Radio />}
					label={option}
					checked={this.state.status === option}
					onChange={this.handleJobStatusChange}
					value={option}
					name={option}
					aria-label={option}
					key={option}
					style={style.statusLabels}
				/>
			);
			html.push(item);
		});
		return html;
	};

	handleJobStatusChange = e => this.setState({ status: e.target.value });

	validate = () => {
		if (
			!this.state.image &&
			(!this.state.imageFilename || this.state.imageFilename.length < 1)
		) {
			this.props.actions.setSnack(true, 'Error: Please Upload an image.');
			this.setState({ imageError: true });
			return;
		}
		if (this.state.imageFile) {
			if (
				!(
					this.state.imageFile.type === 'image/png' ||
					this.state.imageFile.type === 'image/jpg' ||
					this.state.imageFile.type === 'image/jpeg'
				)
			) {
				this.props.actions.setSnack(true, 'Error: Please upload an image.');
				this.setState({ imageError: true });
				return;
			}
		}
		if (
			!this.state.logo &&
			(!this.state.logoFilename || this.state.logoFilename.length < 1)
		) {
			this.props.actions.setSnack(true, 'Error: Please upload a logo.');
			this.setState({ logoError: true });
			return;
		}
		if (this.state.logoFile) {
			if (
				!(
					this.state.logoFile.type === 'image/png' ||
					this.state.logoFile.type === 'image/jpg' ||
					this.state.logoFile.type === 'image/jpeg'
				)
			) {
				this.props.actions.setSnack(true, 'Error: Please upload a logo.');
				this.setState({ logoError: true });
				return;
			}
		}
		if (this.state.company.length < 1) {
			this.props.actions.setSnack(true, 'Error: Please enter a company name.');
			this.setState({ companyError: true });
			return;
		}
		if (this.state.about.length < 1) {
			this.props.actions.setSnack(true, 'Error: Please enter company details.');
			this.setState({ aboutError: true });
			return;
		}
		if (this.state.title.length < 1) {
			this.props.actions.setSnack(true, 'Error: Please enter a job title.');
			this.setState({ titleError: true });
			return;
		}
		if (this.state.location.length < 1) {
			this.props.actions.setSnack(true, 'Error: Please enter a job location.');
			this.setState({ locationError: true });
			return;
		}
		if (this.state.details.length < 1) {
			this.props.actions.setSnack(true, 'Error: Please enter job details.');
			this.setState({ detailsError: true });
			return;
		}
		if (this.state.commission.length < 1) {
			this.props.actions.setSnack(
				true,
				'Error: Please enter a commission amount greater than 1000.'
			);
			this.setState({ commissionError: true });
			return;
		}
		if (!(this.state.commission >= 1000)) {
			this.props.actions.setSnack(
				true,
				'Error: Please enter a commission amount greater than 1000.'
			);
			this.setState({ commissionError: true });
			return;
		}
		if (this.state.status === 'hired') {
			this.setState({ dialogOpen: true, dialogMessage: '' });
			return;
		}
		this.state.imageFile
			? this.uploadImage()
			: this.state.logoFile ? this.uploadLogo() : this.post();
	};

	uploadImage = () => {
		this.setState({ posting: true });
		let { uid, imageFile, jid } = this.state;
		let self = this;
		let meta = { customMetadata: { name: imageFile.name, uid, jid } };
		let storageRef = firebase.storage().ref(`jobs/${uid}/${jid}/${jid}_image`);
		let task = storageRef.put(imageFile, meta);
		task.on(
			'state_changed',
			snapshot => {
				self.setState({
					uploadProgress: snapshot.bytesTransferred / snapshot.totalBytes / 2
				});
			},
			err => {
				this.props.actions.setSnack(
					true,
					'Error uploading image. Please try again.'
				);
				this.setState({ posting: false, uploadProgress: 0 });
				return;
			},
			() => {
				let imageObject = {};
				storageRef
					.getMetadata()
					.then(metadata => {
						imageObject.filename = metadata.customMetadata.name;
						imageObject.bucket = metadata.bucket;
						imageObject.contentType = metadata.contentType;
						imageObject.fullPath = metadata.fullPath;
						imageObject.name = metadata.name;
						imageObject.size = metadata.size;
						imageObject.timeCreated = metadata.timeCreated;
						imageObject.updated = metadata.updated;
						imageObject.downloadURLs = metadata.downloadURLs;
						self.setState({ imageObject });
						this.state.logoFile
							? this.uploadLogo(imageObject)
							: this.post(imageObject, null);
					})
					.catch(storageError => {
						this.props.actions.setSnack(
							true,
							'Error uploading logo. Please try again.'
						);
						this.setState({ posting: false, uploadProgress: 0 });
					});
			}
		);
	};

	uploadLogo = imageObject => {
		this.setState({ posting: true });
		let { uid, logoFile, jid } = this.state;
		let self = this;
		let meta = { customMetadata: { name: logoFile.name, uid, jid } };
		let storageRef = firebase.storage().ref(`jobs/${uid}/${jid}/${jid}_logo`);
		let task = storageRef.put(logoFile, meta);
		task.on(
			'state_changed',
			snapshot => {
				self.setState({
					uploadProgress:
						50 + snapshot.bytesTransferred / snapshot.totalBytes * 49
				});
			},
			err => {
				this.props.actions.setSnack(
					true,
					'Error uploading logo. Please try again.'
				);
				this.setState({ posting: false, uploadProgress: 0 });
				return;
			},
			() => {
				let logoObject = {};
				storageRef
					.getMetadata()
					.then(metadata => {
						console.log(metadata);
						logoObject.filename = metadata.customMetadata.name;
						logoObject.bucket = metadata.bucket;
						logoObject.contentType = metadata.contentType;
						logoObject.fullPath = metadata.fullPath;
						logoObject.name = metadata.name;
						logoObject.size = metadata.size;
						logoObject.timeCreated = metadata.timeCreated;
						logoObject.updated = metadata.updated;
						logoObject.downloadURLs = metadata.downloadURLs;
						self.setState({ logoObject });
						this.post(imageObject, logoObject);
					})
					.catch(storageError => {
						this.props.actions.setSnack(
							true,
							'Error uploading logo. Please try again.'
						);
						this.setState({ posting: false, uploadProgress: 0 });
					});
			}
		);
	};

	post = (imageObject, logoObject) => {
		this.setState({ posting: true, uploadProgress: 95 });
		const {
			company,
			about,
			title,
			location,
			geopoint,
			details,
			status,
			jid,
			qualifications,
			responsibilities,
			companyURI,
			publicJob,
			privateCompanyStats,
			privateOfferStats,
			glassdoorId,
			commission
		} = this.state;
		let promises = [];
		const jobsObj = {
			about,
			commission,
			company,
			details,
			glassdoorId,
			jid,
			location,
			geopoint,
			publicJob,
			privateCompanyStats,
			privateOfferStats,
			qualifications,
			responsibilities,
			status,
			title,
			updated: Date.now()
		};
		if (imageObject) {
			jobsObj.image = imageObject;
		}
		if (logoObject) {
			jobsObj.logo = logoObject;
		}
		if (companyURI) {
			jobsObj.companyURI = companyURI;
		}
		const jobsPromise = firebase
			.firestore()
			.collection('jobs')
			.doc(this.props.match.params.jid)
			.update(jobsObj);
		promises.push(jobsPromise);
		Promise.all(promises)
			.then(() => {
				ReactGoogleAnalytics('Jobs', 'Edit', jid, null, null);
				this.props.actions.setSnack(true, 'Success: Job Update Saved.');
				this.setState({ posting: false, posted: true, uploadProgress: 100 });
				this.props.actions.updateJob(jobsObj);
			})
			.catch(postError => {
				this.props.actions.setSnack(
					true,
					'Error saving job. Please try again.'
				);
				this.setState({ posting: false, posted: false, uploadProgress: 0 });
			});
	};

	handleViewPreviewBtnClick = () =>
		this.setState({ viewPreview: !this.state.viewPreview });

	render() {
		console.log(this.state);
		return (
			<React.Fragment>
				<Head title={`Edit Job | ${Title}`} />
				<div id={this.props.loggedIn ? 'loggedInBody' : null} className="body">
					{this.props.authLoading && (
						<CircularProgress style={style.loading} size={75} />
					)}

					{!this.state.loading &&
						this.props.loggedIn &&
						!this.props.adminLoading &&
						this.props.admin &&
						this.props.myJobsLoading && (
							<SkeletonCard
								header={true}
								media={true}
								content={true}
								actions={true}
							/>
						)}

					{!this.state.loading &&
						this.props.loggedIn &&
						!this.props.adminLoading &&
						this.props.admin &&
						!this.props.myJobsLoading &&
						!!this.props.myJobs[this.props.match.params.jid] &&
						this.props.jobs[this.props.match.params.jid] &&
						this.props.jobs[this.props.match.params.jid] &&
						this.props.jobs[this.props.match.params.jid].status !== 'hired' &&
						!!this.state.job &&
						this.renderForm()}

					{!this.state.loading &&
						this.props.loggedIn &&
						!this.props.adminLoading &&
						this.props.admin &&
						!this.props.myJobsLoading &&
						!!this.props.myJobs[this.props.match.params.jid] &&
						this.props.jobs[this.props.match.params.jid] &&
						this.props.jobs[this.props.match.params.jid] &&
						this.props.jobs[this.props.match.params.jid].status === 'hired' &&
						!!this.state.job &&
						this.renderHiredCard()}

					{!this.state.loading &&
						this.props.loggedIn &&
						!this.props.adminLoading &&
						this.props.admin &&
						!this.props.myJobsLoading &&
						!this.props.myJobs[this.props.match.params.jid] &&
						this.props.jobs[this.props.match.params.jid] &&
						this.props.jobs[this.props.match.params.jid] &&
						this.props.jobs[this.props.match.params.jid].status !== 'hired' &&
						!!this.state.job && (
							<div style={style.unauthorizedContainer}>
								<UnauthorizedText
									text="Error"
									subText="Please check the link and try again"
								/>
							</div>
						)}

					{!this.state.loading &&
						this.props.loggedIn &&
						!this.props.adminLoading &&
						this.props.admin &&
						!this.props.myJobsLoading &&
						!!this.props.myJobs[this.props.match.params.jid] &&
						this.props.jobs[this.props.match.params.jid] &&
						this.props.jobs[this.props.match.params.jid] &&
						this.props.jobs[this.props.match.params.jid].status !== 'hired' &&
						!!this.state.job && (
							<ViewMoreFeedBtn
								key={'view preview'}
								onClickfunction={this.handleViewPreviewBtnClick}
								text={this.state.viewPreview ? 'Hide Prevew' : 'View Preview'}
							/>
						)}
					{!this.state.loading &&
						this.props.loggedIn &&
						!this.props.adminLoading &&
						this.props.admin &&
						!this.props.myJobsLoading &&
						!!this.props.myJobs[this.props.match.params.jid] &&
						this.props.jobs[this.props.match.params.jid] &&
						this.props.jobs[this.props.match.params.jid] &&
						this.props.jobs[this.props.match.params.jid].status !== 'hired' &&
						!!this.state.job &&
						this.state.viewPreview &&
						this.renderPreview()}

					{!this.props.authLoading &&
						this.props.loggedIn &&
						!this.props.adminLoading &&
						!this.props.admin && (
							<div className="unauthorizedTextContainer">
								<UnauthorizedText
									text="Unauthorized"
									subText="Access is limited"
								/>
							</div>
						)}

					{!this.props.authLoading && !this.props.loggedIn && <LoggedOutCard />}
					<DialogAlert
						title={'Confirm Status'}
						content={`Please confirm that you would like to set the job status to ${
							this.state.status
						}. Once set, it cannot be undone.`}
						actions={[
							{
								action: () => {
									this.setState({ dialogOpen: false, dialogMessage: '' });
								},
								content: 'Cancel'
							},
							{
								action: () => {
									this.setState({ dialogOpen: false, dialogMessage: '' });
									this.post();
								},
								content: 'Save'
							}
						]}
						status={this.state.dialogOpen}
					/>
				</div>
			</React.Fragment>
		);
	}
}



// WEBPACK FOOTER //
// ./src/pages/EditJob/EditJob.js